<template>
    <Modal v-model="addresslistshow" title="常用地址" :closable="false" :mask-closable="false" width="800" @on-ok="confirmaddress">
        <div id='Anchor_props' class='addressss transition_dom' v-if='getVipNo&&!isMobile'>
            <template v-for='(address,index) in sortaddresse'>
                <div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)' @mouseenter='hoverActive=address.id' @mouseleave="hoverActive=-1">
                    <div class="left">
                        <span class="name">{{address.name}}</span>
                        <span class="tel">{{address.moblie_phone}}</span>
                        <Tag v-if="address.is_default" class="addressTag" color="#B176C5">默认地址</Tag>
                        <p>
                            <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i>
                            {{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.county}}&nbsp;&nbsp;{{address.town}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;
                        </p>
                    </div>
                </div>
            </template>
        </div>
        <div id='Anchor_props' class='addressss transition_dom' v-else-if="isMobile&&getVipNo">
            <template v-for='(address,index) in sortaddresse'>
                <div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)'>
                    <div class="left">
                        <span class="name">{{address.name}}</span>
                        <span class="tel">{{address.moblie_phone}}</span>
                        <Tag v-if="address.is_default" class="addressTag" color="#B176C5">默认地址</Tag>
                        <p>
                            <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i>
                            {{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp;{{address.county}}&nbsp;&nbsp;{{address.town}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;
                        </p>
                    </div>
                </div>
            </template>
        </div>
        <span v-if='addresses.length > 4' class="showAllAddr" @click='operating'>{{isAllAddress?'收起地址':'显示全部地址'}}&nbsp;<b>&gt;</b></span>
    </Modal>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { addressMethods} from "@/components/common/mixin";
export default {
	data() {
		return {
			addresslistshow: false,
			isAllAddress: false,
			hoverActive: -1,
			addresses: [],
        }
    },
    mixins:[addressMethods],
    computed: {
		...mapGetters(["getVipNo"]),
		...mapState({
			userInfo: (state) => state.common.wechatUserInfo.value,
			choosedAddress: (state) => state.order.choosedAddress,
		}),
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
		qchoosedAddress: function () {
			return this.choosedAddress || {};
		},
		sortaddresse: function () {
			this.addresses = this.userInfo.binding && (this.userInfo.binding.address || []);
			if(this.addresses.length){
				return this.addresses.sort(function (a, b) {
					return b.is_default - a.is_default;
				});
			}else{
				return [];
			}
		},
    },
    mounted() {
        this.$nextTick(function() {
            this.initData();
        })
    },
    methods:{
        ...mapActions([
        ]),
        async initData(){
        },
		open(){
			if(this.addresslistshow){
				this.addresslistshow = false;
			}else{
				this.addresslistshow = true;
			}
		},
        chooseAddress(address){
            this.$emit('chooseAddress',address);
        },
        confirmaddress(){
            this.$emit('confirmaddress');
        },
		operating() {
			this.isAllAddress = !this.isAllAddress;
		},
    },
}
</script>
<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.addressss {
	@include fontSize($font-size-15);
	overflow: hidden;
	.item {
		cursor: pointer;
		width: 100%;
		border: 1px solid #eee;
		padding: 10px;
		overflow: hidden;
		margin-bottom: 15px;
		&.select {
			border-color: $theme-color;
			border-width: 2px;
			&.hover {
				border-width: 2px;
			}
		}
		&.hover {
			border-color: $theme-color;
			border-width: 1px;
		}
		.left {
			float: left;
			i {
				display: inline-block;
				font-style: normal;
				@include fontSize($font-size-13);
				color: #fff;
				margin-right: 3px;
			}
		}
		.right {
			float: right;
			position: relative;
			top: 20px;
			img {
				width: 15px;
			}
		}
		.name {
		}
		.tel {
			margin-left: 20px;
			margin-right: 10px;
		}
		p {
			padding-top: 3px;
		}
	}
}
.showAllAddr {
	color: $theme-color;
	font-weight: 500;
	border-bottom: 1px solid #fff;
	display: block;
	cursor: pointer;
	@include fontSize($font-size-14);
	// margin-bottom: 20px;
}
.transition_dom {
	transition: all 0.3s linear 0s;
}
</style>